import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { formatNumber } from '../../main-page/home-utils';

// informative only, the default rate the design shows
const DEFAULT_RATE = 4.2;

export const LoanCalculator = ({ price }) => {
    const { t } = useTranslation(["details"]);
    const [down, setDown] = useState(20);
    const [years, setYears] = useState(25);
    const [rate, setRate] = useState(DEFAULT_RATE);

    const loan = price * (1 - down / 100);
    const monthlyRate = rate / 100 / 12;
    const monthly = loan * monthlyRate / (1 - Math.pow(1 + monthlyRate, -years * 12));

    return (
        <section className='hs-det-section'>
            <h2>{t('calc_title')}</h2>
            <div className='hs-calc'>
                <div className='hs-calc-inputs'>
                    <label>
                        <span><span>{t('calc_down')}</span><strong>{down}% · {formatNumber(price * down / 100)} €</strong></span>
                        <input type='range' min='10' max='60' step='5' value={down} onChange={(e) => setDown(Number(e.target.value))} />
                    </label>
                    <label>
                        <span><span>{t('calc_period')}</span><strong>{t('calc_years', { n: years })}</strong></span>
                        <input type='range' min='5' max='30' step='1' value={years} onChange={(e) => setYears(Number(e.target.value))} />
                    </label>
                    <label>
                        <span><span>{t('calc_rate')}</span><strong>{rate.toFixed(1).replace('.', ',')}%</strong></span>
                        <input type='range' min='1' max='10' step='0.1' value={rate} onChange={(e) => setRate(Number(e.target.value))} />
                    </label>
                    <span className='hs-calc-note'>{t('calc_note')}</span>
                </div>
                <div className='hs-calc-result'>
                    <span>{t('calc_monthly')}</span>
                    <span className='hs-calc-monthly'>{formatNumber(monthly)} €</span>
                    <span>{t('calc_loan', { amount: `${formatNumber(loan)} €` })}</span>
                    <Link to='/kredit'>{t('calc_guide')} →</Link>
                </div>
            </div>
        </section>
    );
};
